import { useContext } from 'react';
import { CompanyContext } from 'src/contexts/CompanyContext';

const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) throw new Error('company context must be used inside company Provider');
  return context;
};

export default useCompany;
